import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Layout/Header';
import Nutritionsidebar from '../Layout/Nutritionsidebar';
import Nutritionreport from './Nutritionreport';
import '../Style/nutrition.css';

export default function Nutrition_Panel({ dietReportData }) {
    const [isActive, setActive] = useState("div1");


    return (
        <div className='min-h-screen bg-cover flex flex-col text-white w-full' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='flex flex-1 flex-col lg:flex-row'>
                <div className='Player-dashboard-content flex flex-grow w-full'>
                    {isActive === 'div1' && <Nutritionreport dietReportData={dietReportData} />}
                </div>
            </div>
        </div>
    );
}
